webpackJsonp([2],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cache */
/* unused harmony export getCache */
/* harmony export (immutable) */ __webpack_exports__["b"] = cacheState;
/* harmony export (immutable) */ __webpack_exports__["a"] = cachedState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_storage__ = __webpack_require__(255);



function cache(key, value) {
  __WEBPACK_IMPORTED_MODULE_1__utils_storage__["a" /* default */].saveItem(key, value, window.localStorage);
}

function getCache(key) {
  return __WEBPACK_IMPORTED_MODULE_1__utils_storage__["a" /* default */].getItem(key);
}

function cacheState(state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
    cache(key, state[key]);
  });
}

function cachedState(state, skipProps) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
    if (skipProps && skipProps.indexOf(key) > -1) {
      return;
    }
    var cached = getCache(key);
    if (cached != null) {
      state[key] = cached;
    }
  });
  return state;
}

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateEmail */
/* unused harmony export delegate */
/* unused harmony export downloadFile */
/* unused harmony export setterFor */
/* unused harmony export mapValueProps */
/* unused harmony export mapStoreProps */
/* unused harmony export mapObjectMutations */
/* unused harmony export mapEmitProps */
/* unused harmony export mapEmitProp */
/* unused harmony export hasClass */
/* unused harmony export addClass */
/* unused harmony export removeClass */
/* unused harmony export toggleClass */
/* unused harmony export extractNetworkError */
/* harmony export (immutable) */ __webpack_exports__["b"] = extractNetworkErrorMessage;
/* unused harmony export guid */
/* unused harmony export dataURItoBlob */
/* unused harmony export hashCode */
/* unused harmony export getImageSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isProd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_i18n_i18n__ = __webpack_require__(66);










var i18n = __WEBPACK_IMPORTED_MODULE_8__services_i18n_i18n__["a" /* default */].getInstance();

function validateEmail(email) {
  var emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
  return emailRegex.test(email);
}

function delegate(object, attributes) {
  return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.reduce(attributes, function (acc, key, value) {
    acc[key] = function () {
      return this[object] && this[object][key];
    };
    return acc;
  }, {});
}

function downloadFile(urls) {
  var url = void 0;
  if (typeof urls === 'string') {
    url = urls;
  } else if (urls.length) {
    url = urls[0];
  } else {
    return false;
  }

  var fileName = url.split('/').pop();
  var link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.dispatchEvent(new window.MouseEvent('click'));
  return true;
}

function setterFor(key) {
  return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.camelCase('set-' + key);
}

function mapValueProps(properties, setter) {
  var props = {};
  properties.forEach(function (prop) {
    props[prop] = {
      get: function get() {
        return this.value && this.value[prop];
      },
      set: function set(newValue) {
        if (setter == null) {
          this.$emit('input', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, prop, newValue)));
        } else {
          setter(prop, newValue, this);
        }
      }
    };
  });
  return props;
}

function mapStoreProps(object, properties) {
  var props = {};
  properties.forEach(function (prop) {
    props[prop] = {
      get: function get() {
        return this[object] && this[object][prop];
      },
      set: function set(newValue) {
        this[setterFor(prop)](newValue);
      }
    };
  });
  return props;
}

function mapObjectMutations(keyPath, props) {
  return props.reduce(function (acc, key) {
    acc[setterFor(key)] = function (state, value) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(state, keyPath), key, value);
    };
    return acc;
  }, {});
}

function mapEmitProps(properties) {
  var props = {};
  properties.forEach(function (prop) {
    props[prop] = {
      get: function get() {
        return this.value && this.value[prop];
      },
      set: function set(newValue) {
        this.$emit('input', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, prop, newValue)));
      }
    };
  });

  return props;
}

function mapEmitProp(property) {
  return {
    property: {
      get: function get() {
        return this.value && this.value[property];
      },
      set: function set(newValue) {
        this.$emit('input', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, property, newValue)));
      }
    }
  };
}

function hasClass(obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

function addClass(obj, cls) {
  if (!hasClass(obj, cls)) obj.className += ' ' + cls;
}

function removeClass(obj, cls) {
  if (hasClass(obj, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    obj.className = obj.className.replace(reg, ' ');
  }
}

function toggleClass(obj, cls) {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls);
  } else {
    addClass(obj, cls);
  }
}

function extractNetworkError(error) {
  var data = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(error, 'response.data');
  if (data) {
    if (data.length > 0) {
      return error.response.data[0];
    } else if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) === 'object') {
      var errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(data);
      var _error = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(errors, '[0][0]');
      return _error && { description: _error };
    }
  }

  return null;
}

function extractNetworkErrorMessage(error) {
  var networkError = extractNetworkError(error);
  if (networkError == null && error && error.response && error.response.status >= 400) {
    return i18n.t('messages:errorOccuredMessage');
  }
  if (error.code === 'ECONNABORTED') {
    return i18n.t('messages:errorOccuredMessage');
  }
  return networkError && networkError.description;
}

function guid() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += window.performance.now();
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

function dataURItoBlob(dataURI) {
  var byteString = window.atob(dataURI.split(',')[1]);

  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new window.Blob([ab], { type: mimeString });
  return blob;
}

function hashCode(stringOrObject) {
  if ((typeof stringOrObject === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(stringOrObject)) === 'object') {
    stringOrObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stringOrObject);
  }
  var hash = 0;
  var i = void 0;
  var chr = void 0;
  var len = void 0;

  if (stringOrObject.length === 0) return hash;
  for (i = 0, len = stringOrObject.length; i < len; i++) {
    chr = stringOrObject.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

function getImageSize(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var reader = new window.FileReader();
    var useBlob = false && window.URL;
    reader.addEventListener('load', function () {
      var image = new window.Image();
      image.addEventListener('load', function () {
        resolve({
          width: image.width,
          height: image.height
        });
        if (useBlob) {
          window.URL.revokeObjectURL(image.src);
        }
      });
      image.src = useBlob ? window.URL.createObjectURL(file) : reader.result;
    });
    reader.readAsDataURL(file);
  });
}

var isProd = "production" === 'production';

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["capitalizeFirstLetter"] = capitalizeFirstLetter;
/* harmony export (immutable) */ __webpack_exports__["defaultValue"] = defaultValue;
/* harmony export (immutable) */ __webpack_exports__["fileSize"] = fileSize;
/* harmony export (immutable) */ __webpack_exports__["join"] = join;
/* harmony export (immutable) */ __webpack_exports__["prefix"] = prefix;
/* harmony export (immutable) */ __webpack_exports__["resizeUrl"] = resizeUrl;
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function defaultValue(value, defaultValue) {
  return value != null ? value : defaultValue;
}

function fileSize(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (bytes === 0) return '0 Byte';
  var k = 1024;
  var dm = decimals + 1 || 2;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function join(array) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';

  return array.join(delimiter);
}

function prefix(string, prefixer) {
  return '' + prefixer + string;
}

function resizeUrl(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      width = _ref.width,
      height = _ref.height,
      _ref$mode = _ref.mode,
      mode = _ref$mode === undefined ? 'crop' : _ref$mode;

  if (url == null) {
    return '';
  }
  if (url.indexOf('?') > -1) {
    url += '&';
  } else {
    url += '?';
  }

  var query = [];

  if (width) {
    query.push('width=' + width);
  }

  if (height) {
    query.push('height=' + height);
  }

  if (width && height) {
    query.push('mode=' + (mode || 'crop'));
  }

  return '' + url + query.join('&');
}

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(151);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  linkActiveClass: 'active',

  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  if (to.name === 'home') {
    next();
  } else {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.flowType == null) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_help_flow__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_create_flow__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_i18n_i18n__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(100);










var t = __WEBPACK_IMPORTED_MODULE_6__services_i18n_i18n__["a" /* default */].getInstance().getFixedNamespaceT('settings');

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production';

function validateFlowType(flowType) {
  if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* flowTypes */][flowType] == null) {
    throw Error('flowType ' + flowType + ' does not exist');
  }
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    createFlow: __WEBPACK_IMPORTED_MODULE_4__modules_create_flow__["a" /* default */],
    helpFlow: __WEBPACK_IMPORTED_MODULE_3__modules_help_flow__["a" /* default */]
  },

  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* cachedState */])({
    flowType: null,
    stepIndex: -1
  }),

  getters: {
    header: function header(state, getters) {
      if (state.flowType == null) {
        return t('options.header');
      }
      return getters.currentStep && getters.currentStep.header;
    },
    subHeader: function subHeader(state, getters) {
      if (state.flowType == null) {
        return null;
      }
      return getters.currentStep && getters.currentStep.subHeader;
    },
    description: function description(state, getters) {
      if (state.flowType == null) {
        return t('options.description');
      }
      return getters.currentStep && getters.currentStep.description;
    },
    canGoBack: function canGoBack(state, getters) {
      return state.flowType != null;
    },
    totalSteps: function totalSteps(state) {
      if (__WEBPACK_IMPORTED_MODULE_5__config__["b" /* steps */][state.flowType]) {
        return __WEBPACK_IMPORTED_MODULE_5__config__["b" /* steps */][state.flowType].filter(function (s) {
          return !!s.skipStep === false;
        }).length;
      }
      return 0;
    },
    skipStep: function skipStep(state, getters) {
      return getters.currentStep && getters.currentStep.skipStep || false;
    },
    stepNumber: function stepNumber(state) {
      if (state.stepIndex < 0) {
        return null;
      }
      return state.stepIndex + 1;
    },
    wizardText: function wizardText(state, getters) {
      if (getters.stepNumber && state.flowType != null) {
        if (state.flowType === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* flowTypes */].SELF) {
          return t('self.wizard');
        } else if (state.flowType === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* flowTypes */].HELP) {
          return t('help.wizard');
        }
      }
      return null;
    },
    currentFlow: function currentFlow(state) {
      return state.flowType && __WEBPACK_IMPORTED_MODULE_5__config__["b" /* steps */][state.flowType];
    },
    currentRouteName: function currentRouteName(state, getters) {
      return getters.currentStep && getters.currentStep.routeName;
    },
    currentStep: function currentStep(state, getters) {
      if (state.stepIndex < 0) {
        return;
      }

      return getters.currentFlow && getters.currentFlow[state.stepIndex];
    },
    bgClass: function bgClass(state, getters) {
      return getters.currentStep && getters.currentStep.bgClass || 'bg-white';
    }
  },

  mutations: {
    setFlowType: function setFlowType(state, flowType) {
      validateFlowType(flowType);
      state.flowType = flowType;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* cacheState */])(state);
    },
    setStep: function setStep(state, stepIndex) {
      state.stepIndex = stepIndex;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* cacheState */])(state);
    },
    incrementStep: function incrementStep(state) {
      state.stepIndex += 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* cacheState */])(state);
    },
    decreaseStep: function decreaseStep(state) {
      if (state.stepIndex < 0) {
        console.warn('try to descrease the stepIndex while its less than 0');
        return;
      }
      state.stepIndex -= 1;
      if (state.stepIndex < 0) {
        state.flowType = null;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* cacheState */])(state);
    },
    reset: function reset(state) {
      state.flowType = null;
      state.stepIndex = -1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* cacheState */])(state);
    }
  },

  actions: {
    chooseFlowType: function chooseFlowType(_ref, flowType) {
      var commit = _ref.commit,
          getters = _ref.getters,
          dispatch = _ref.dispatch;

      commit('setFlowType', flowType);
      commit('setStep', 0);
      dispatch('updateRoute');
    },
    chooseSelfFlow: function chooseSelfFlow(_ref2) {
      var dispatch = _ref2.dispatch;

      dispatch('chooseFlowType', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* flowTypes */].SELF);
    },
    chooseHelpFlow: function chooseHelpFlow(_ref3) {
      var dispatch = _ref3.dispatch;

      dispatch('chooseFlowType', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* flowTypes */].HELP);
    },
    proceed: function proceed(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state,
          dispatch = _ref4.dispatch;

      if (state.flowType == null || state.stepIndex < 0) {
        throw Error('flowType does not exist');
      }

      if (state.stepIndex >= __WEBPACK_IMPORTED_MODULE_5__config__["b" /* steps */][state.flowType].length - 1) {
        console.warn('already last step!');
        return;
      }
      commit('incrementStep');
      dispatch('updateRoute');
    },
    proceedToFinal: function proceedToFinal(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state,
          getters = _ref5.getters,
          dispatch = _ref5.dispatch;

      commit('setStep', getters.totalSteps - 1);
      dispatch('updateRoute');
    },
    goBack: function goBack(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('decreaseStep');
      dispatch('updateRoute');
    },
    updateRoute: function updateRoute(_ref7) {
      var getters = _ref7.getters,
          state = _ref7.state;

      if (getters.currentRouteName) {
        return __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: getters.currentRouteName });
      } else if (state.flowType == null) {
        return __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: 'home' });
      }
    },
    reset: function reset(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      commit('reset');
      dispatch('createFlow/reset');
      dispatch('helpFlow/reset');
      dispatch('updateRoute');
    }
  },

  strict: debug,

  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default.a] : []
}));

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_i18n__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_task__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_toast__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bluebird__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_global__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_analytics__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_analytics__);


















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__directives__["a" /* installDirectives */])(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__components_global__["installComponents"])(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11_bluebird___default.a.config({ cancellation: true });

if (__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* isProd */]) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */]);
} else {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */]);
}

__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_6__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__services_task__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__services_toast__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__services_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_analytics___default.a, {
  id: 'UA-93831786-1',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_3__App___default.a)).$mount('#app');

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(545),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["installComponents"] = installComponents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoIcon__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LogoIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Picture__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Picture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Picture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskLoading__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TaskLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoadingButton__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoadingButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LoadingButton__);





function installComponents(Vue) {
  Vue.component('yz-picture', __WEBPACK_IMPORTED_MODULE_1__Picture___default.a);
  Vue.component('yz-spinner', __WEBPACK_IMPORTED_MODULE_0__LogoIcon___default.a);
  Vue.component('yz-task-loading', __WEBPACK_IMPORTED_MODULE_2__TaskLoading___default.a);
  Vue.component('yz-loading-button', __WEBPACK_IMPORTED_MODULE_3__LoadingButton___default.a);
}

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(548),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiEndpointBaseUrl; });
/* unused harmony export loginBaseUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loginUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(101);


var useProdEndpoint = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isProd */] && __webpack_require__.i({"NODE_ENV":"production"}).BUILD_ENV !== 'staging';

var apiEndpointBaseUrl = useProdEndpoint ? 'https://api.yourzite.com' : 'http://dev.api.yourzite.com';

var loginBaseUrl = useProdEndpoint ? 'https://login.yourzite.com' : 'http://dev.login.yourzite.com';

var loginUrl = function loginUrl(token) {
  return loginBaseUrl + '/admin?memberToken=' + token + '&viaSignUp=true';
};

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__site_config__ = __webpack_require__(222);



var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_1__site_config__["b" /* apiEndpointBaseUrl */],
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'nl-NL',
    'X-Country': 'nl'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  return {
    getCategories: function getCategories() {
      return instance.get('/templates').then(function (resp) {
        return resp.data;
      });
    },
    signup: function signup(_ref) {
      var siteName = _ref.siteName,
          email = _ref.email,
          password = _ref.password,
          phoneNumber = _ref.phoneNumber,
          templateId = _ref.templateId;

      return instance.post('/account/signup', {
        siteName: siteName,
        email: email,
        password: password,
        phoneNumber: phoneNumber,
        templateId: templateId
      });
    },
    createLead: function createLead(_ref2) {
      var name = _ref2.name,
          email = _ref2.email,
          phoneNumber = _ref2.phoneNumber,
          companyName = _ref2.companyName,
          hasWebsite = _ref2.hasWebsite,
          wannaCopySite = _ref2.wannaCopySite,
          currentWebsiteUrl = _ref2.currentWebsiteUrl,
          packageId = _ref2.packageId;

      return instance.post('/leads', {
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        companyName: companyName,
        hasWebsite: hasWebsite,
        wannaCopySite: wannaCopySite,
        currentWebsiteUrl: currentWebsiteUrl,
        package: packageId
      });
    }
  };
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend__ = __webpack_require__(241);


function install(Vue, options) {
  var api = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__backend__["a" /* default */])(options);
  Vue.api = api;
  Vue.prototype.$api = api;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installDirectives;
function installDirectives(Vue) {
  Vue.directive('flex-order', function (el, _ref) {
    var value = _ref.value;

    el.style.order = value;
  });
}

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (path) {
  return function (resolve) {
    __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(561)("./" + path)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  };
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_resolver__ = __webpack_require__(244);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'home',
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('Start')
}, {
  path: '/self',
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('Entry'),
  children: [{
    name: 'chooseCategory',
    path: 'choose-category',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('self/ChooseCategory')
  }, {
    name: 'chooseTemplate',
    path: 'choose-template',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('self/ChooseTemplate')
  }, {
    name: 'selfSignUp',
    path: 'sign-up',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('self/SignUp')
  }]
}, {
  path: '/help',
  name: 'Home',
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('Entry'),
  children: [{
    name: 'websiteEnquiry',
    path: 'website',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('help/WebsiteEnquery')
  }, {
    name: 'choosePackage',
    path: 'choose-package',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('help/ChoosePackage')
  }, {
    name: 'helpSummary',
    path: 'summary',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('help/Summary')
  }, {
    name: 'helpSignUp',
    path: 'sign-up',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('help/SignUp')
  }, {
    name: 'helpConfirmation',
    path: 'thank-you',
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__component_resolver__["a" /* default */])('help/Confirmation')
  }]
}]);

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(66);


function install(Vue) {
  var i18n = __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].getInstance();

  Vue.t = function (key, options) {
    return i18n.translate(key, options);
  };

  Vue.prototype.$t = function (key, options) {
    var defualts = this.$options.ns ? { ns: this.$options.ns } : {};
    return i18n.translate(key, options, defualts);
  };

  Vue.prototype.$translateHtml = function (key) {
    return i18n.translateHtml(key);
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin__ = __webpack_require__(248);


function install(Vue) {
  Vue.mixin(__WEBPACK_IMPORTED_MODULE_0__mixin__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task__ = __webpack_require__(249);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    if (this.$options.tasks) {
      var tasks = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$options.tasks).reduce(function (acc, key) {
        var val = _this.$options.tasks[key];

        var _ref = function () {
          var isTaskObject = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) === 'object' && typeof val.task === 'function';
          if (isTaskObject) {
            return [val.task, val.concurrencyType || __WEBPACK_IMPORTED_MODULE_4__task__["a" /* TaskConcurrency */].default];
          } else {
            return [val, __WEBPACK_IMPORTED_MODULE_4__task__["a" /* TaskConcurrency */].default];
          }
        }(),
            _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            task = _ref2[0],
            concurrencyType = _ref2[1];

        acc[key] = new __WEBPACK_IMPORTED_MODULE_4__task__["b" /* Task */](task.bind(_this), concurrencyType);
        return acc;
      }, {});

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tasks);
    }
    return {};
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaskConcurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Task; });
/* unused harmony export task */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bluebird__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bluebird__);









var TaskConcurrency = {
  default: 0,
  restartable: 1,
  sharedReplay: 2
};

var Task = function () {
  function Task(task, concurrencyType) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Task);

    if (concurrencyType != null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(TaskConcurrency).indexOf(concurrencyType) < 0) {
      concurrencyType = TaskConcurrency.default;
      console.warn('incorrect concurrencyType ' + concurrencyType + ',\n        should be one of ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(TaskConcurrency));
    }
    if (task == null) {
      throw Error('task cannot be empty');
    }

    this._taskId = 0;
    this._taskDict = {};
    this.task = task;
    this.error = null;
    this.concurrencyType = concurrencyType || TaskConcurrency.default;
    this.state = {
      isRunning: false,
      isCanceld: false,
      isSuccessful: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Task, [{
    key: 'restartable',
    value: function restartable() {
      this.concurrencyType = TaskConcurrency.sharedReplay;
      return this;
    }
  }, {
    key: 'sharedReplay',
    value: function sharedReplay() {
      this.concurrencyType = TaskConcurrency.restartable;
      return this;
    }
  }, {
    key: 'resetState',
    value: function resetState() {
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isRunning', false);
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isCanceld', false);
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isSuccessful', false);
    }
  }, {
    key: 'cancelAll',
    value: function cancelAll() {
      this._cancelAll();
    }
  }, {
    key: '_addTask',
    value: function _addTask(taskId, task) {
      this._taskDict[taskId] = task;
      return task;
    }
  }, {
    key: '_removeTask',
    value: function _removeTask(taskId) {
      if (this._taskDict[taskId]) {
        delete this._taskDict[taskId];
      }
    }
  }, {
    key: '_cancelAll',
    value: function _cancelAll() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this._taskDict).forEach(function (task) {
        task.cancel();
      });
      this._taskDict = {};
    }
  }, {
    key: 'perform',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var taskId, _task, wrappedPromise, value;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isRestartable) {
                  this._cancelAll();
                }
                taskId = this.isSharedReplay ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._taskDict)[0] || this._taskId++ : this._taskId++;


                this.error = null;

                _context.prev = 3;

                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isRunning', true);
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isSuccessful', false);

                _task = this._taskDict[taskId];


                if (_task == null) {
                  wrappedPromise = new __WEBPACK_IMPORTED_MODULE_7_bluebird___default.a(function (resolve, reject, onCancel) {
                    if (onCancel) {
                      args.push(onCancel);
                    }
                    return resolve(_this.task.apply(_this, args));
                  });

                  _task = this._addTask(taskId, wrappedPromise);
                }

                _context.next = 10;
                return _task;

              case 10:
                value = _context.sent;

                this._removeTask(taskId);

                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isRunning', false);
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isSuccessful', true);
                return _context.abrupt('return', value);

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](3);

                console.error(_context.t0);
                this.error = _context.t0;
                this._removeTask(taskId);
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isRunning', false);
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.state, 'isSuccessful', false);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 17]]);
      }));

      function perform() {
        return _ref.apply(this, arguments);
      }

      return perform;
    }()
  }, {
    key: 'isRestartable',
    get: function get() {
      return this.concurrencyType === TaskConcurrency.restartable;
    }
  }, {
    key: 'isSharedReplay',
    get: function get() {
      return this.concurrencyType === TaskConcurrency.sharedReplay;
    }
  }, {
    key: 'isIdle',
    get: function get() {
      return !this.state.isRunning;
    }
  }, {
    key: 'isRunning',
    get: function get() {
      return this.state.isRunning;
    }
  }, {
    key: 'isSuccessful',
    get: function get() {
      return this.state.isSuccessful;
    }
  }, {
    key: 'hasError',
    get: function get() {
      return this.error != null;
    }
  }]);

  return Task;
}();

function task() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return new (Function.prototype.bind.apply(Task, [null].concat(args)))();
}

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export skipValidationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultPipeline; });
/* harmony export (immutable) */ __webpack_exports__["b"] = extractErrorWithPipeline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(101);


var skipValidationError = function skipValidationError(error) {
  if (error.validationErrors) {
    return null;
  }
  return [];
};

var extractErrorMessage = function extractErrorMessage(error) {
  console.log(error);
  return error && error.message;
};

var defaultPipeline = [__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* extractNetworkErrorMessage */], extractErrorMessage];

function extractErrorWithPipeline(error, pipeline) {
  var result = pipeline.reduce(function (acc, handler) {
    if (acc == null) {
      return;
    }

    var result = handler(error);

    if (result == null) {
      return acc;
    }

    if (typeof result === 'string') {
      acc.messages.push(result);
      return acc;
    } else if (result.length > 0) {
      acc.messages.push(result[0]);
      return acc;
    } else {
      return acc;
    }
  }, { messages: [] });

  if (result && result.messages.length > 0) {
    return result.messages[0];
  }
}

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_i18n_i18n__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__(250);






var t = __WEBPACK_IMPORTED_MODULE_4__services_i18n_i18n__["a" /* default */].getInstance().getFixedNamespaceT('messages');

var toasts = [];

function Toast(Vue) {
  var HIDE_DELAY = 2500;

  var ToastBase = {
    props: {
      title: String,
      content: {
        type: String,
        required: true
      },
      autoHide: {
        type: [Boolean, Number],
        default: HIDE_DELAY
      },
      level: {
        type: String,
        defualt: 'info'
      }
    },
    mounted: function mounted() {
      var _this = this;

      this.$nextTick(function () {
        _this.visible = true;
        if (_this.autoHide) {
          var delay = typeof _this.autoHide === 'boolean' ? HIDE_DELAY : _this.autoHide;
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.delay(function () {
            _this.visible = false;
          }, delay);
        }
      });
    },

    computed: {
      levelClass: function levelClass() {
        return this.level;
      }
    },
    methods: {
      close: function close() {
        this.visible = false;
      }
    }
  };

  var TopToastContructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ToastBase, {
    template: '\n      <transition name="slide-down" @after-leave="$emit(\'leave-transition-ended\')">\n        <div class="toast toast-top" :class="levelClass" v-show="visible">\n          <div class="global-width-tiny">\n            <slot>\n              <p class="margin-0 text-center" v-html="content">\n              </p>\n            </slot>\n          </div>\n        </div>\n      </transition>\n    '
  }));

  var TopCornerToastContructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ToastBase, {
    template: '\n      <transition name="slide-left" @after-leave="$emit(\'leave-transition-ended\')">\n        <div class="toast toast-general toast-plain" :class="levelClass" v-show="visible">\n          <div class="toast-content">\n            <h4 class="toast-heading" v-if="title">{{ title }}</h4>\n            <span>{{ content }}</span>\n          </div>\n        </div>\n      </transition>\n    '
  }));

  var BottomCornerToastContructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ToastBase, {
    template: '\n      <transition name="slide-left" @after-leave="$emit(\'leave-transition-ended\')">\n        <div class="toast toast-general toast-form" :class="levelClass" v-show="visible">\n          <div class="toast-content">\n            <h4 class="toast-heading">{{ title }}</h4>\n            <slot>\n              <div v-html="content">\n              </div>\n            </slot>\n          </div>\n        </div>\n      </transition>\n    '
  }));

  var ToastTypes = {
    'top': TopToastContructor,
    'top-corner': TopCornerToastContructor,
    'bottom-corner': BottomCornerToastContructor
  };

  var ToastLevels = ['info', 'error', 'warning'];

  var defaultOptions = {
    autoHide: HIDE_DELAY,
    hideOthers: true,
    level: 'info',
    type: 'top'
  };

  function initInstance(props, options) {
    var ToastContructor = ToastTypes[options.type];
    return new ToastContructor({
      data: {
        visible: false
      },
      el: document.createElement('template'),
      propsData: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, {
        autoHide: options.autoHide,
        level: options.level
      })
    });
  }

  function validateOptions(options) {
    if (ToastTypes[options.type] == null) {
      console.debug('Toast type ' + options.type + ' does not exist');
    }
    if (ToastLevels.indexOf(options.level) < 0) {
      console.debug('Toast level \'' + options.level + '\' is incorrect, should be ' + ToastLevels);
    }
  }

  function show(props, options) {
    options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultOptions, options);
    props = typeof props === 'string' ? { content: props } : props;

    validateOptions(options);

    if (options.hideOthers) {
      hideAll();
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var instance = initInstance(props, options);
      var insertedEl = instance.$el;
      if (!instance) {
        throw Error('Failed to init toast');
      }
      document.body.appendChild(instance.$el);
      instance.$nextTick(function () {
        toasts.push(instance);
        instance.$on('leave-transition-ended', function (_) {
          instance.$nextTick(function (_) {
            document.body.removeChild(insertedEl);
            instance.$destroy();
          });
        });
        instance.$nextTick(function (_) {
          resolve(instance);
        });
      });
    });
  }

  function hideAll() {
    toasts.forEach(function (toast) {
      toast.close();
    });
    toasts = [];
  }

  function hideTopmost() {
    var topmost = toasts.pop();
    if (topmost) {
      topmost.close();
    }
  }

  function hide(toast) {
    if (toast == null) {
      return;
    }
    var idx = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(toasts, { _uid: toast._uid });
    if (idx > -1) {
      toasts[idx].close();
      toasts.splice(idx, 1);
    }
  }

  function showMessage(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    show(content, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      autoHide: 2000,
      type: 'top'
    }, options, {
      level: 'info'
    }));
  }

  function showInfo(_ref) {
    var title = _ref.title,
        content = _ref.content;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    show({ title: title, content: content }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      type: 'top-corner',
      autoHide: 2000
    }, options, {
      level: 'info'
    }));
  }

  function showError(error) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pipeline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__error__["a" /* defaultPipeline */];

    var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__error__["b" /* extractErrorWithPipeline */])(error, pipeline);

    if (message) {
      showErrorMessage(message, options);
    }
  }

  function showErrorMessage(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    show(content || t('general.errorTitle'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      autoHide: 3000,
      type: 'top'
    }, options, {
      level: 'error'
    }));
  }

  return {
    show: show,
    showMessage: showMessage,
    showInfo: showInfo,
    showError: showError,
    showErrorMessage: showErrorMessage,
    hide: hide,
    hideAll: hideAll,
    hideTopmost: hideTopmost
  };
}

function install(Vue) {
  Vue.prototype.$toast = Toast(Vue);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flowTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return steps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_i18n_i18n__ = __webpack_require__(66);


var _steps;


var t = __WEBPACK_IMPORTED_MODULE_1__services_i18n_i18n__["a" /* default */].getInstance().getFixedNamespaceT('settings');

var flowTypes = {
  SELF: 'SELF',
  HELP: 'HELP'
};

var steps = (_steps = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_steps, flowTypes.SELF, [{
  header: t('self.chooseCategory.header'),
  description: t('self.chooseCategory.description'),
  routeName: 'chooseCategory',
  bgClass: 'bg-blue'
}, {
  header: t('self.chooseTemplate.header'),
  description: t('self.chooseTemplate.description'),
  routeName: 'chooseTemplate',
  bgClass: 'bg-white'
}, {
  header: t('self.form.header'),
  subHeader: t('self.form.subHeader'),
  routeName: 'selfSignUp',
  bgClass: 'bg-blue'
}]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_steps, flowTypes.HELP, [{
  header: t('help.websiteEnquiry.header'),
  routeName: 'websiteEnquiry',
  bgClass: 'bg-blue'
}, {
  header: t('help.choosePackage.header'),
  routeName: 'choosePackage',
  bgClass: 'bg-blue'
}, {
  header: t('help.form.header'),
  routeName: 'helpSignUp',
  bgClass: 'bg-blue'
}, {
  header: t('help.confirmation.header'),
  routeName: 'helpConfirmation',
  skipStep: true,
  bgClass: 'bg-white'
}]), _steps);

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(100);






var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* cachedState */])({
  availableCategories: null,
  category: null,
  template: null
});

var getters = {
  categories: function categories(state) {
    return state.availableCategories && state.availableCategories.categories;
  },
  emptyTemplate: function emptyTemplate(state) {
    return state.availableCategories && state.availableCategories.emptyTemplate;
  }
};

var mutations = {
  setCategories: function setCategories(state, categories) {
    state.availableCategories = categories;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* cacheState */])(state);
  },
  setCategory: function setCategory(state, category) {
    state.category = category;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* cacheState */])(state);
  },
  setTemplate: function setTemplate(state, template) {
    state.template = template;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* cacheState */])(state);
  },
  reset: function reset(state) {
    state.availableCategories = null;
    state.category = null;
    state.template = null;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* cacheState */])(state);
  }
};

var actions = {
  getCategories: function getCategories(_ref) {
    var _this = this;

    var state = _ref.state,
        commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var categories;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.availableCategories) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', state.availableCategories);

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].api.getCategories();

            case 4:
              categories = _context.sent;

              commit('setCategories', categories);
              return _context.abrupt('return', categories);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  chooseCategory: function chooseCategory(_ref2, category) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('setCategory', category);
    return dispatch('proceed', null, { root: true });
  },
  chooseTemplate: function chooseTemplate(_ref3, template) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('setTemplate', template);
    return dispatch('proceed', null, { root: true });
  },
  chooseEmptyTemplate: function chooseEmptyTemplate(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    commit('setCategory', null);
    commit('setTemplate', getters.emptyTemplate);
    return dispatch('proceedToFinal', null, { root: true });
  },
  createWebsite: function createWebsite(_ref5, params) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].api.signup(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
      templateId: state.template && state.template.id
    }));
  },
  reset: function reset(_ref6) {
    var commit = _ref6.commit;

    commit('reset');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(56);






var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* cachedState */])({
  website: null,
  needsCopy: false,
  sitePackage: null
});

var getters = {
  hasWebsite: function hasWebsite(state) {
    return state.website != null;
  }
};

var mutations = {
  setWebsite: function setWebsite(state, website) {
    state.website = website;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* cacheState */])(state);
  },
  setNeedsCopy: function setNeedsCopy(state, needsCopy) {
    state.needsCopy = needsCopy;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* cacheState */])(state);
  },
  setSitePackage: function setSitePackage(state, sitePackage) {
    state.sitePackage = sitePackage;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* cacheState */])(state);
  },
  reset: function reset(state) {
    state.website = null;
    state.needsCopy = false;
    state.sitePackage = null;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* cacheState */])(state);
  }
};

var actions = {
  setWebsite: function setWebsite(_ref, website) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('setWebsite', website);
    return dispatch('proceed', null, { root: true });
  },
  setSitePackage: function setSitePackage(_ref2, sitePackage) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('setSitePackage', sitePackage);
    return dispatch('proceed', null, { root: true });
  },
  createLead: function createLead(_ref3, params) {
    var _this = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        state = _ref3.state,
        getters = _ref3.getters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].api.createLead(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, {
                hadAWebsite: getters.hasWebsite != null,
                wannaCopySite: state.needsCopy,
                currentWebsiteUrl: state.website,
                packageId: state.sitePackage.id
              }));

            case 2:
              return _context.abrupt('return', dispatch('proceed', null, { root: true }));

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  reset: function reset(_ref4) {
    var commit = _ref4.commit;

    commit('reset');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var fallbackStore = {};

var isLocalStorageNameSupported = function isLocalStorageNameSupported() {
  var testKey = 'test';
  try {
    window.localStorage.setItem(testKey, '1');
    window.localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  getItem: function getItem(key, storage) {
    if (!isLocalStorageNameSupported) {
      return fallbackStore[key];
    }

    try {
      var data = storage != null ? storage.getItem(key) : window.sessionStorage.getItem(key) || window.localStorage.getItem(key);
      if (data) {
        return JSON.parse(data);
      }
    } catch (e) {
      return null;
    }

    return null;
  },
  saveItem: function saveItem(key, data) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.sessionStorage;

    if (!isLocalStorageNameSupported) {
      fallbackStore[key] = data;
      return;
    }
    storage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  },
  removeItem: function removeItem(key, storage) {
    if (!isLocalStorageNameSupported) {
      delete fallbackStore[key];
      return;
    }

    if (storage) {
      storage.removeItem(key);
    } else {
      window.sessionStorage.removeItem(key) || window.localStorage.removeItem(key);
    }
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init8Digits;
function init8Digits() {
  if (window._eightDigitsInitialized) {
    return;
  }
  window._trackingCode = 'rq840ctp';
  (function () {
    var wa = document.createElement('script');wa.type = 'text/javascript';wa.async = true;
    wa.src = '//cdn.8digits.com/automation.js';
    var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(wa, s);
    window._eightDigitsInitialized = true;
  })();
}

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_TopBar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_TopBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_TopBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendors_8digits__ = __webpack_require__(256);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  mounted: function mounted() {
    this.$store.dispatch('updateRoute');
    this.$store.dispatch('createFlow/getCategories');
    this.$nextTick(function (_) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vendors_8digits__["a" /* init8Digits */])();
    });
  },


  components: {
    TopBar: __WEBPACK_IMPORTED_MODULE_0_components_TopBar___default.a
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    layout: {
      type: String,
      default: 'horizontal'
    },
    theme: {
      type: String,
      default: 'dark',
      validator: function validator(value) {
        return ['light', 'dark'].indexOf(value) > -1;
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isHorizontal: function isHorizontal() {
      return this.layout === 'horizontal';
    },
    size: function size() {
      return {
        width: 366,
        height: 76
      };
    },
    width: function width() {
      return this.size.width + 'px';
    },
    height: function height() {
      return this.size.height + 'px';
    },
    viewport: function viewport() {
      return '0 0 ' + this.size.width + ' ' + this.size.height;
    },
    isLight: function isLight() {
      return this.theme === 'light';
    },
    iconStyle: function iconStyle() {
      return this.isHorizontal ? { transform: 'translate3d(0, 0, 0)' } : { transform: 'translate3d(144px, -92px, 0)' };
    },
    textStyle: function textStyle() {
      return this.isHorizontal ? { transform: 'translate3d(105px, 17px, 0)' } : { transform: 'translate3d(56px, 0, 0)' };
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(143);






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['header', 'description', 'subHeader', 'stepNumber', 'totalSteps', 'wizardText', 'canGoBack', 'skipStep']), {
    previousRoute: function previousRoute() {
      if (this.previousRouteName) {
        return { name: this.previousRouteName };
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['goBack'])),

  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__Logo___default.a
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    defaultText: String,
    disabledText: String,
    loadingText: {
      type: String,
      default: function _default() {
        return this.$t('loading');
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: function _default() {
        return ['btn', 'loading-btn'];
      }
    },
    spinnerSize: {
      type: String,
      default: '20px'
    },
    spinnerColor: {
      type: String,
      default: '#242424'
    }
  },

  computed: {
    buttonClasses: function buttonClasses() {
      if (this.classes == null) {
        return null;
      }

      return this.classes;
    },
    text: function text() {
      return this.isLoading ? this.loadingText : this.disabled ? this.disabledText || this.defaultText : this.defaultText;
    }
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    width: {
      type: Number,
      default: 60
    },

    isLoading: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'light',
      validator: function validator(value) {
        return ['light', 'dark'].indexOf(value) > -1;
      }
    }
  },

  computed: {
    isLight: function isLight() {
      return this.theme === 'light';
    },
    iconStyle: function iconStyle() {
      return {
        width: this.width + 'px',
        height: 'auto'
      };
    }
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__(149);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alt: String,
    supportsRetina: {
      type: Boolean,
      defualt: true
    },
    image: {
      type: String,
      required: true
    },
    width: Number,
    height: Number,
    fitMode: {
      type: String,
      default: 'crop',
      validator: function validator(value) {
        return ['max', 'pad', 'crop', 'stretch', 'carve'];
      }
    }
  },

  computed: {
    dir: function dir() {
      if (this.image && (this.image[0] === '/' || /(http(s?)):\/\//i.test(this.image))) {
        return '';
      } else {
        return '/static/images/';
      }
    },
    imgSrcset: function imgSrcset() {
      if (this.dir.length) {
        return '' + this.dir + this.image;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters__["resizeUrl"])(this.image, { width: this.width, height: this.height, mode: this.mode || 'crop' });
    },
    imgRetinaSrcset: function imgRetinaSrcset() {
      if (this.dir.length) {
        return '' + this.dir + this.retinaImage;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters__["resizeUrl"])(this.image, { width: this.width * 2, height: this.height * 2, mode: this.mode || 'crop' });
    },
    sourceSrcset: function sourceSrcset() {
      return this.imgSrcset + ', ' + this.imgRetinaSrcset + ' 2x';
    },
    retinaImage: function retinaImage() {
      var parts = this.image.split('.');
      if (parts.length > 1) {
        parts[parts.length - 2] = parts[parts.length - 2] + '@2x';
        return parts.join('.');
      } else {
        throw Error('illigal image name ' + this.image);
      }
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    task: {
      type: Object,
      required: true
    },
    autoRun: {
      type: Boolean,
      default: true
    },
    canRetry: {
      type: Boolean,
      default: true
    },
    showError: {
      type: Boolean,
      default: true
    },
    loadingText: String,
    errorText: String
  },

  beforeMount: function beforeMount() {
    if (this.autoRun) {
      this.task.perform();
    }
  },


  computed: {
    isLoading: function isLoading() {
      return this.task.isRunning;
    },
    errorMessage: function errorMessage() {
      return this.errorText || this.$t('failedLoadingData');
    }
  },

  methods: {
    retry: function retry() {
      return this.task.perform();
    }
  }
});

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports = "<h2 class=\"fw-extra-bold\">\r\n  Wat kan je ondertussen al doen?\r\n</h2>\r\n<ul class=\"common-list\">\r\n  <li>Heb je al mooie foto’s die je graag wil gebruiken?</li>\r\n  <li>Heb je misschien een <a target=\"_blank\" href=\"https://www.yourzite.com/nl/websites\" class=\"underlined-link\">template</a> gezien die je erg mooi vindt?</li>\r\n  <li>Heb je al nagedacht over teksten op je website?</li>\r\n  <li>Heb je misschien een voorkeur voor bepaalde kleuren?</li>\r\n</ul>\r\n\r\n<div class=\"margin-top-l\">\r\n  <h3 class=\"fw-extra-bold\">Of kijk eens op:</h3>\r\n  <div class=\"stack-h stack-h--center m-stack-v m-stack-v--start\">\r\n    <div class=\"stack-h stack-h--center\">\r\n      <img src=\"/static/images/icons/ic_facebook.png\" alt=\"facebook\" class=\"margin-right-xs\">\r\n      <a target=\"_blank\" href=\"http://www.facebook.com/yourzite\" class=\"underlined-link m-margin-left-m\">.com/<strong>YourZite</strong></a>\r\n    </div>\r\n    <div class=\"stack-h stack-h--center margin-left-xl m-margin-left-0 m-margin-top-m\">\r\n      <img src=\"/static/images/icons/ic_insta.png\" alt=\"instagram\" class=\"margin-right-xs\">\r\n      <a target=\"_blank\" href=\"http://www.instagram.com/yourzite\" class=\"underlined-link m-margin-left-m\">.com/<strong>YourZite</strong></a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports = "<div class=\"bottom-logo visible-m\">\r\n  <picture>\r\n    <source srcset=\"/static/images/logo-white.png, /static/images/logo-white@2x.png 2x\">\r\n    <img src=\"/static/images/logo-white.png\" srcset=\"/static/images/logo-white.png\" alt=\"YourZite\">\r\n  </picture>\r\n</div>\r\n\r\n<div class=\"columns global-width\">\r\n  <div class=\"col-21 hidden-m\">\r\n    <div class=\"block links\">\r\n      <span class=\"label\">\r\n        <picture>\r\n          <source srcset=\"/static/images/logo-white.png, /static/images/logo-white@2x.png 2x\">\r\n          <img src=\"/static/images/logo-white.png\" srcset=\"/static/images/logo-white.png\" alt=\"YourZite\">\r\n        </picture>\r\n      </span>\r\n      <ul>\r\n        <li><a href=\"http://www.yourzite.com/nl/design-op-maat\">Design op maat</a></li>\r\n      </ul>\r\n      <ul>\r\n        <li><a href=\"http://www.yourzite.com/nl/mogelijkheden\">Mogelijkheden</a></li>\r\n        <li><a href=\"http://www.yourzite.com/nl/hoe-het-werkt\">Hoe het werkt</a></li>\r\n      </ul>\r\n      <ul>\r\n        <li><a href=\"http://www.yourzite.com/nl/over-ons\">Over ons</a></li>\r\n        <li><a href=\"http://www.yourzite.com/nl/algemene-voorwaarden\">Algemene voorwaarden</a></li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-31 company\">\r\n    <div class=\"block company-info\">\r\n      <span class=\"label\">Je kunt ons bereiken:</span>\r\n      <div class=\"contact-info\">\r\n        <p><strong>ma t/m vr&nbsp;09:00 tot 17:30 uur</strong></p>\r\n        <div class=\"tels\"><span class=\"label\">T:</span>\r\n        <p><span class=\"tel\">+31 (0)299 200 805</span></p>\r\n        </div>\r\n        </div>\r\n        <div class=\"address\">\r\n        <p><strong>YourZite</strong></p>\r\n        <p>Wilhelminalaan 1C</p>\r\n        <p>1441 EK Purmerend</p>\r\n        <p>Nederland</p>\r\n        <p><span class=\"label\">@:</span> <a class=\"email\" href=\"mailto:info@yourzite.com\">info@yourzite.com</a></p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"bottom columns global-width\">\r\n  <ul class=\"social-links\">\r\n    <li>\r\n      <a href=\"https://www.facebook.com/yourzite/\" target=\"_blank\">\r\n        <img src=\"/static/images/icons/invis.gif\" class=\"icon facebook\" alt=\"Facebook\">\r\n      </a>\r\n    </li>\r\n    <li>\r\n      <a href=\"https://www.instagram.com/yourzite/\" target=\"_blank\">\r\n        <img src=\"/static/images/icons/invis.gif\" class=\"icon instagram\" alt=\"Instagram\">\r\n      </a>\r\n    </li>\r\n  </ul>\r\n  <p class=\"copyright\">© 2017 YourZite // <a href=\"http://www.yourzite.com/nl/cookie\">Cookiegebruik</a></p>\r\n</div>"

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports = "<h6 class=\"title\">Kan je niet vinden wat je zoekt?</h6>\r\n<p>We hebben ook standaard templates in de volgende categorieën:<a href=\"#\">bedrijven</a>, <a href=\"#\">evenementen</a>, <a href=\"#\">beauty en welness</a>, <a href=\"#\">fotografie</a>, <a href=\"#\">portfolio's en CV's</a>, <a href=\"#\">persoonlijk</a>, <a href=\"#\">muziek</a>, <a href=\"#\">winkels</a>.</p>"

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
  __webpack_require__(518)
}
var Component = __webpack_require__(41)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-sc",
    attrs: {
      "id": "app"
    }
  }, [_c('top-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "site-content"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo",
    attrs: {
      "viewBox": _vm.viewport,
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "logo-icon logo-element",
    class: {
      animating: _vm.isLoading
    },
    style: (_vm.iconStyle)
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#123C4C' : '#123C4C',
      "points": "45.9 53 56.1 56 61.2 61.8 45.9 70.6 30.6 61.8 36.6 56.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "30.6 44.1 45.9 53 38.2 57.4 30.6 61.8 15.3 53 22.6 46.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "61.2 44.1 69.1 46.5 76.5 53 61.2 61.8 53.5 57.4 45.9 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "61.2 44.1 61.2 26.5 69.3 29.3 76.5 35.3 76.5 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "30.6 44.1 30.6 26.5 22.7 29 15.3 35.3 15.3 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "30.6 26.5 22.7 29 15.3 35.3 30.6 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "61.2 26.5 69.1 29 76.5 35.3 61.2 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "76.5 17.7 91.7 26.5 76.5 35.3 61.2 26.5 67.8 21.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "15.3 17.7 0 26.5 15.3 35.3 30.6 26.5 25.2 20.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "61.2 8.8 76.5 17.7 61.2 26.5 45.9 17.7 52.4 12.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "30.6 8.8 15.3 17.7 30.6 26.5 45.9 17.7 40.2 12.4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "points": "45.9 0 45.9 0 45.9 0 61.2 8.8 45.9 17.7 30.6 8.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "logo-element",
    style: (_vm.textStyle),
    attrs: {
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M27.9,9.5 L21.1,29.6 L14.4,9.5 L0.5,9.5 L14.4,45.3 L14.1,46 C13.7,46.9 12.1,47.4 9.5,47.4 C8.6,47.4 7.5,47.2 6.7,46.7 L4.9,58.4 C6.1,58.8 9.1,59 10,59 C17.4,58.8 23.3,57.2 26.4,49.1 L41.7,9.5 L27.9,9.5 L27.9,9.5 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M58,8.6 C45.5,8.6 38.2,17.2 38.2,27.1 C38.2,37 45.5,45.6 58,45.6 C70.6,45.6 77.9,36.9 77.9,27.1 C77.8,17.2 70.5,8.6 58,8.6 Z M58,34 C54,34 51.7,31 51.7,27.1 C51.7,23.2 54,20.2 58,20.2 C62.1,20.2 64.4,23.2 64.4,27.1 C64.3,31 62.1,34 58,34 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M103.8,31.2 C102.7,32.4 101.2,34 98.3,34 C95.1,34 93.2,32.6 93.2,29 L93.2,9.5 L80,9.5 L80,34.7 C80,40.8 83.5,45.6 91.7,45.6 C97.9,45.6 101.8,43 103.8,40.8 L103.8,44.7 L117,44.7 L117,9.5 L103.9,9.5 L103.9,31.2 L103.8,31.2 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M132.7,13.3 L132.7,9.4 L119.6,9.4 L119.6,44.7 L132.7,44.7 L132.7,24.9 C135.3,21 138.2,21 143.5,20.9 L143.5,9.5 C139.5,9.5 134.9,10.8 132.7,13.3 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Shape",
      "fill": "#123C4C",
      "points": "176.5 18.8 176.5 9.6 146.1 9.6 146.1 21 158.5 21 146.1 35.2 146.1 44.8 176.8 44.8 176.8 33.4 163.8 33.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-path",
      "fill": "#123C4C",
      "x": "179.2",
      "y": "9.6",
      "width": "13.1",
      "height": "35.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,34.1 C214.9,34.1 213.8,32.6 213.8,30.8 L213.8,21 L221,21 L221,9.6 L213.8,9.6 L213.8,0 L200.7,0 L200.7,9.6 L194.9,9.6 L194.9,21 L200.7,21 L200.7,34.7 C200.7,42.1 205,45.8 212.8,45.8 C217.3,45.8 220.3,44.7 221.7,43.5 L219.4,33.6 C219,33.7 217.9,34.1 216.7,34.1 Z",
      "fill": "#123C4C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M259.7,28.3 C259.7,15.9 251.7,8.5 241.4,8.5 C230,8.5 222.2,16.7 222.2,27 C222.2,35.2 226.5,41.1 232.9,43.8 L245.8,36.4 C239.1,35.7 236.5,33.4 235.8,31.1 L254.9,31.1 L259.7,28.3 Z M235.6,22.8 C236,21.2 237.4,18.6 241.4,18.6 C245.6,18.6 246.9,21.3 247.2,22.8 L235.6,22.8 Z",
      "fill": "#123C4C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M260.7,28.5 C260.7,16.1 252.7,8.7 242.4,8.7 C231,8.7 223.2,16.9 223.2,27.2 C223.2,35.4 227.5,41.3 233.9,44 L246.8,36.6 C240.1,35.9 237.5,33.6 236.8,31.3 L255.9,31.3 L260.7,28.5 Z M236.6,22.9 C237,21.3 238.4,18.7 242.4,18.7 C246.6,18.7 247.9,21.4 248.2,22.9 L236.6,22.9 Z",
      "fill": "#123C4C"
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo-icon",
    class: {
      animating: _vm.isLoading
    },
    style: (_vm.iconStyle),
    attrs: {
      "width": "92px",
      "height": "71px",
      "viewBox": "0 0 92 71",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#123C4C' : '#123C4C',
      "points": "45.9 53 56.1 56 61.2 61.8 45.9 70.6 30.6 61.8 36.6 56.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "30.6 44.1 45.9 53 38.2 57.4 30.6 61.8 15.3 53 22.6 46.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "61.2 44.1 69.1 46.5 76.5 53 61.2 61.8 53.5 57.4 45.9 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "61.2 44.1 61.2 26.5 69.3 29.3 76.5 35.3 76.5 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "30.6 44.1 30.6 26.5 22.7 29 15.3 35.3 15.3 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "30.6 26.5 22.7 29 15.3 35.3 30.6 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "61.2 26.5 69.1 29 76.5 35.3 61.2 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "76.5 17.7 91.7 26.5 76.5 35.3 61.2 26.5 67.8 21.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "15.3 17.7 0 26.5 15.3 35.3 30.6 26.5 25.2 20.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "61.2 8.8 76.5 17.7 61.2 26.5 45.9 17.7 52.4 12.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "30.6 8.8 15.3 17.7 30.6 26.5 45.9 17.7 40.2 12.4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "points": "45.9 0 45.9 0 45.9 0 61.2 8.8 45.9 17.7 30.6 8.8"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.sourceSrcset
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "srcset": _vm.imgSrcset,
      "alt": _vm.alt
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: [{
      'disabled': _vm.disabled,
      'loading': _vm.isLoading
    }, _vm.buttonClasses],
    attrs: {
      "disabled": _vm.disabled || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.$emit('click', $event)
      }
    }
  }, [(_vm.isLoading) ? _c('yz-spinner', {
    attrs: {
      "size": _vm.spinnerSize,
      "is-loading": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _vm._t("default") : _vm._e(), _vm._v("\n  " + _vm._s(_vm.text) + "\n")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    },
    on: {
      "after-enter": function($event) {
        _vm.$emit('transitionEnd', this)
      }
    }
  }, [(_vm.loadingText && _vm.isLoading) ? _c('div', [_c('yz-spinner', {
    key: "spinner",
    staticClass: "center",
    attrs: {
      "color": "#1b90f5"
    }
  }), _vm._v(" "), (_vm.loadingText) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.loadingText))]) : _vm._e()], 1) : (_vm.isLoading) ? _c('yz-spinner', {
    key: "spinner",
    staticClass: "centered",
    attrs: {
      "color": "#1b90f5"
    }
  }) : (_vm.showError && _vm.task.error) ? _c('div', {
    staticClass: "error-container text-center"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('errorView.title')))]), _vm._v(" "), _c('article', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), (_vm.canRetry) ? _c('p', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.retry($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('errorView.tryAgain')))])]) : _vm._e()])]) : (_vm.$slots.default) ? _c('div', {
    key: "main"
  }, [_vm._t("default")], 2) : (_vm.$slots.root) ? _vm._t("root") : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar__top-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.stepNumber && !_vm.skipStep) ? _c('span', {
    staticClass: "top-bar__wizard"
  }, [_c('span', {
    staticClass: "m-hidden"
  }, [_vm._v(_vm._s(_vm.wizardText))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.stepNumber))]), _vm._v(" / " + _vm._s(_vm.totalSteps))]) : _vm._e()], 1), _vm._v(" "), _c('header', {
    staticClass: "top-bar__header"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.canGoBack && !_vm.skipStep) ? _c('button', {
    staticClass: "top-bar__back btn-link",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/icons/ic_arrow_left.svg",
      "alt": _vm.$t('back')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "underlined"
  }, [_vm._v(_vm._s(_vm.$t('back')))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('h1', {
    key: _vm.header,
    staticClass: "margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.header) + "\n      ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.subHeader) ? _c('h3', {
    key: _vm.subHeader,
    staticClass: "margin-bottom-0 margin-top-0"
  }, [_vm._v("\n        " + _vm._s(_vm.subHeader) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.description) ? _c('p', {
    key: _vm.description,
    staticClass: "margin-top-ms"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./nl-NL/common.json": 557
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./confirmation.html": 534,
	"./footer.html": 535,
	"./more-templates.html": 536
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports = {"yes":"ja","no":"nee","back":"Terug","options":{"header":"Wie gaat de website maken?","description":"Ben of ken jij iemand die handig is met teksten schrijven, foto’s maken en deze te combineren tot een mooie website? Dan kan je dit zelf doen. Heb je hier geen tijd voor, geen zin in of gewoon niet zoveel gevoel voor? Geen nood, wij kunnen je ook helpen!","self":{"title":"Ik ga de website <br /> <span class=\"emphasis\"><strong>zelf</strong> maken</span>","button":"ga verder met je website","note":"Na het kiezen van een template die je mooi vindt, kan je direct aan de slag en vul je de bouwblokken in naar eigen smaak."},"help":{"title":"Ik ga de website door  <br /><span class=\"emphasis\">YourZite <strong>laten</strong> maken</span> ","button":"geef je wensen door","note":"Na het beantwoorden van enkele vragen zullen we contact met je opnemen om je wensen door te nemen."}},"self":{"wizard":"wie gaat de website maken?","chooseCategory":{"header":"Om je te helpen...","description":"... bieden wij tientallen templates aan die al door ons zijn ontworpen en waar jij gratis gebruik van kan maken. Kies onderstaand een categorie waar je website volgens jou bijhoort. Zo ben je al lekker op weg naar je nieuwe website!","title":"Kies een categorie:","or":"of","choose":"Kies een categorie","footnote":"Alle bouwblokken zijn volledig naar wens aan te passen en je hebt geen technische kennis nodig!"},"chooseTemplate":{"header":"Kies een template","description":"Kies één van onze standaard templates als basis voor je website. Onze standaard templates zijn volledig aanpasbaar op basis van jouw wensen, oftewel alle bouwblokken kan je wijzigen of verwijderen en je kunt nieuwe toevoegen.","others":"zet je website zelf in elkaar","example":"voorbeeld","choose":"kies","startWithNew":"Start met een witte pagina","makeYourOwn":"Maak jouw eigen template"},"form":{"header":"Je gaat zelf je website maken...","subHeader":"Vul hieronder je gegevens in","siteName":"websitenaam","siteNamePlaceholder":"Gewenste websitenaam","siteNameTip":"Jouw websitenaam wordt ook jouw tijdelijke URL, oftewel websitenaam.yourzite-trials.com. Let op, de websitenaam moet uniek zijn en mag alleen letters, cijfers en het karakter - bevatten. Dus ook geen spaties.","siteNameRequired":"De websitenaam is een verplicht veld","email":"e-mailadres","emailPlaceholder":"Vul hier je e-mailadres in","emailTip":"Hiermee kan je later weer opnieuw inloggen en naar dit adres versturen wij het wachtwoord indien je deze bent vergeten.","emailInvalid":"E-mailadres is onjuist, voer een ander e-mailadres in.","emailRequired":"E-mailadres is verplicht","password":"wachtwoord","passwordPlaceholder":"Bedenk een wachtwoord","passwordTip":"Met dit wachtwoord kan je altijd weer inloggen om je website aan te passen.","passwordRequired":"Wachtwoord is verplicht","passwordInvalid":"Het wachtwoord moet minimaal bestaan uit 6 karakters.","phone":"telefoonnummer","phonePlaceholder":"Vul je telefoonnummer in","phoneRequired":"Telefoonnummer is verplicht","phoneTip":"Dit is niet verplicht maar op deze manier kunnen wij je nog beter helpen met het maken van een mooie website.","goNext":"ga verder","makingWebsite":"","waitPlease":"Even geduld alsjeblieft"}},"help":{"wizard":"Kies een categorie","websiteEnquiry":{"header":"We gaan je helpen...","haveWebsite":"Als eerste willen we weten: <strong class=\"fw-extra-bold\">Heb je al een website</strong>?","willingCopy":"Wil je dat we alle inhoud van je huidige website overnemen?","willingCopyDesc":"Voor <strong>€99</strong> importeren we alle teksten en afbeeldingen om ze voor de nieuwe website te gebruiken.","websiteUrl":"Wat is het website adres (URL) van de huidige website?","websiteUrlDesc":"Het website adres (URL) staat in de adresbalk van de browser en begint met www.","websiteUrlPlaceholder":"Vul je website adres (URL) in","goNext":"ga door","enterWebsite":"Het ingevulde website adres (URL) is onjuist. "},"choosePackage":{"header":"We gaan je helpen...","title":"Hoe groot moet je website worden?","desc":"Kies een grootte die aansluit bij je wensen.","consistOf":"De website bestaat uit:","chooseFor":"kies deze voor","package1":{"title":"1 pagina"},"package2":{"title":"2 t/m 6 pagina's"},"package3":{"title":"meer dan 6 pagina's"}},"summary":{"header":"We gaan je helpen...","title":"Samenvattend...","desc":"Hieronder staat een overzicht van de informatie die we van jou hebben ontvangen:","callBack":"Neem contact met mij op","hasWebsite":"Je hebt al een website.","hasNoWebsite":"Je hebt geen website.","package":"Je nieuwe website moet {{packageName}} groot worden.","websiteUrl":"De URL van je website is <strong>{{url}}</strong>","copyWebsite":"Je wil dat wij de content voor je gaan overzetten naar je nieuwe website.","notCopyWebsite":"Je hebt ervoor gekozen om zelf de content toe te voegen aan je nieuwe website."},"form":{"header":"YourZite neemt contact met je op...","subHeader":"vul hieronder je gegevens in","name":"naam","namePlaceholder":"Vul je naam in","nameRequired":"Naam is verplicht","nameTip":"Vul hier je naam in.","email":"e-mailadres","emailPlaceholder":"Vul hier je e-mailadres in","emailTip":"Wij zullen contact met je opnemen via dit e-mailadres.","emailInvalid":"E-mailadres is onjuist, voer een ander e-mailadres in.","emailRequired":"E-mailadres is verplicht","siteNameRequired":"De websitenaam is een verplicht veld","phone":"telefoonnummer","phonePlaceholder":"Vul je telefoonnummer in","phoneRequired":"Telefoonnummer is verplicht","phoneTip":"Wij zullen contact met je opnemen via dit telefoonnummer.","companyName":"bedrijfsnaam","companyNamePlaceholder":"Vul je bedrijfsnaam in","companyNameTip":"Vul hier je bedrijfsnaam in."},"confirmation":{"header":"Bedankt voor je aanmelding,","subHeader":"We zullen binnen 48 uur contact met je opnemen!"}}}

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(214);
module.exports = __webpack_require__(213);


/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18next__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18next_xhr_backend__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18next_xhr_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_i18next_xhr_backend__);






var instance = null;

var I18n = function () {
  function I18n() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, I18n);

    if (instance != null) {
      this.i18next = __WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */];
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_i18next_xhr_backend___default.a).init({
      debug: "production" !== 'production',


      load: 'currentOnly',

      initImmediate: false,

      lng: 'nl-NL',

      fallbackLng: 'en-US',

      preload: ['nl-NL'],

      defaultNS: 'common',

      fallbackNS: 'common',

      ns: ['common'],

      joinArrays: ' ',

      backend: {
        loadPath: '{{lng}}/{{ns}}',
        parse: function parse(data) {
          return data;
        },
        jsonIndent: 2,
        ajax: function ajax(url, options, callback, data) {
          try {
            callback(__webpack_require__(555)("./" + url + '.json'), { status: '200' });
          } catch (e) {
            callback(null, { status: '404' });
          }
        }
      }
    });
    this.i18next = __WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */];
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(I18n, [{
    key: 't',
    value: function t() {
      return this.translate.apply(this, arguments);
    }
  }, {
    key: 'getFixedNamespaceT',
    value: function getFixedNamespaceT(namespace) {
      return this.i18next.getFixedT(null, namespace);
    }
  }, {
    key: 'translate',
    value: function translate(key, options) {
      var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.i18next.t(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaults, options));
    }
  }, {
    key: 'translateHtml',
    value: function translateHtml(key) {
      return __webpack_require__(556)("./" + key + '.html');
    }
  }], [{
    key: 'getInstance',
    value: function getInstance() {
      if (instance == null) {
        instance = new I18n();
      }
      return instance;
    }
  }]);

  return I18n;
}();

/* harmony default export */ __webpack_exports__["a"] = (I18n);

/***/ })

},[558]);


// WEBPACK FOOTER //
// static/js/app.6434b0bc04bf77478209.js